export const isSignWithoutMinimumDatasetEnabled = (form) => form?.signWithOutMinimumDataset === 1;

export const isUnableToAssessWoundEnabled = (form) => form?.unableToAssessWound === 1;

export const hasAtLeastOneSignCriterion = (form) => Boolean(form?.characteristics?.length || form?.measurements?.length || form?.treatment?.length);

export const hasPatientRefusalReason = (form) => Boolean(form?.patientRefusalReasons?.length);

export const isDispalyBinaryImageNo = (form) => form?.displayBinaryImage === 0;
